import React, { Component } from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { getSEO } from "../services/seoService";

export class Blogs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      seo: null,
      blogs: [],
      loading: false,
      hasMore: true,
    };
  }

  async componentDidMount() {
    try {
      const seoData = await getSEO("blogs");

      const response = await fetch(
        "https://idealtechnoride.in/api/blogs",
        {
          method: "POST",
        }
      );

      const blogs = await response.json();

      this.setState({
        seo: seoData,
        blogs: blogs || [],
        hasMore: blogs.length > 0,
      });
    } catch (error) {
      console.log(error);
    }
  }

  loadMoreBlogs = async () => {
    try {
      const { blogs } = this.state;

      if (blogs.length === 0) return;

      const lastId = blogs[blogs.length - 1].blogs_id;

      const formData = new FormData();
      formData.append("blogs_id", lastId);

      this.setState({
        loading: true,
      });

      const response = await fetch(
        "https://idealtechnoride.in/api/blogs",
        {
          method: "POST",
          body: formData,
        }
      );

      const data = await response.json();

      this.setState((prevState) => ({
        blogs: [...prevState.blogs, ...data],
        hasMore: data.length > 0,
        loading: false,
      }));
    } catch (error) {
      console.log(error);

      this.setState({
        loading: false,
      });
    }
  };

  render() {
    const { seo, blogs, loading, hasMore } = this.state;

    return (
      <div>
        <SEO seo={seo} />

        {/* Hero Start */}
        <div className="container-fluid pb-5 hero-header mb-5">
          <div className="container py-5">
            <div className="row g-3 align-items-center">
              <div className="col-lg-6 text-center text-lg-start">
                <h1 className="display-3 mb-0 animated slideInLeft">
                  Blogs
                </h1>
              </div>

              <div className="col-lg-6 animated slideInRight">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb justify-content-center justify-content-lg-end mb-0">
                    <li className="breadcrumb-item">
                      <Link className="text-secondary" to="/">
                        Home
                      </Link>
                    </li>

                    <li className="breadcrumb-item active">
                      Blogs
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
        {/* Hero End */}

        {/* Blog Start */}
        <div className="container py-5">
          <div className="row g-4">

            {blogs.length > 0 ? (
              blogs.map((blog) => (
                <div
                  key={blog.blogs_id}
                  className="col-lg-4 col-md-6"
                >
                  <div className="blog-item bg-light rounded overflow-hidden h-100">

                    <img
                      className="img-fluid w-100 blog_image"
                      src={blog.blogs_banner_image}
                      alt={blog.blogs_title}
                    />

                    <div className="p-4">

                      <small className="text-muted">
                        {blog.blogs_publish_date}
                      </small>

                      <h5 className="mt-2">
                        {blog.blogs_title}
                      </h5>

                      <p>
                        {blog.blogs_short_description}
                      </p>

                      <Link
                        to={`/blogdetail/${blog.blogs_slug}`}
                        className="btn btn-primary btn-sm"
                      >
                        Read More
                      </Link>

                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <h4>No Blogs Found</h4>
              </div>
            )}

          </div>

          {hasMore && blogs.length > 0 && (
            <div className="text-center mt-5">
              <button
                className="btn btn-primary px-4 py-2"
                onClick={this.loadMoreBlogs}
                disabled={loading}
              >
                {loading ? "Loading..." : "View More"}
              </button>
            </div>
          )}

        </div>
        {/* Blog End */}
      </div>
    );
  }
}

export default Blogs;